/**
 * Region codes as people say them.
 *
 * The config stores IN, US and EU, which are unambiguous once you know them and
 * meaningless until you do. A screen that decides what customers are charged
 * should not ask its reader to decode anything.
 */
const REGION_NAMES = {
    IN: 'India',
    US: 'United States',
    EU: 'Europe',
};

export const regionName = (code) => REGION_NAMES[code] || code;

/** "₹ INR", or just the code when a region has no pricing yet. */
export const regionCurrency = (pricing, code) => {
    const symbol = pricing?.symbol ? `${pricing.symbol} ` : '';
    return `${symbol}${pricing?.currency || code}`;
};
